import React from "react";
import PropTypes from "prop-types";
import styles from "./NoteIcon.module.css";
import { ReactComponent as Note } from "./speaker-notes.svg";

/**
 * Interactive icon used to view notes for an event snapshot
 */

export function NoteIcon({ onClick }) {
  return (
    <div className={styles.container}>
      <Note className={styles.noteIcon} alt="Note Icon" onClick={onClick} />
    </div>
  );
}

NoteIcon.propTypes = {
  // Function called when the icon is clicked
  onClick: PropTypes.func,
};

NoteIcon.defaultProps = {
  onClick: () => alert("note icon clicked"),
};
